/* Let's put everything here */

  jQuery(function($){

    $('.sf-menu').superfish({ 
      delay:       500,               // one second delay on mouseout 
      animation:   {opacity:'show'},  // fade-in and slide-down animation 
      speed:       1,                 // faster animation speed 
      autoArrows:  false,             // disable generation of arrow mark-up 
      dropShadows: false              // disable drop shadows 
    });

    var url;
    $('#small-nav select').change(function() {
      url = $('#small-nav select option:selected').val();
      window.location = url;
    });

  });

  $(function() {
    $('#small-nav .sub-option').each(function() {
      if ($(this).val()  ===  window.location.pathname) {
        $(this).attr("selected","selected");
      }
    });
  });

  $('.flexslider').flexslider({
    animation: "slide",
    controlNav: true,
    controlsContainer: ".flex-container"  
  });

  
  jQuery(function($){
    $('[name="checkout"], input[name="goto_pp"], input[name="goto_gc"]').click(function() {
      if($('#agree').is(':checked')){
        $(this).submit();
      }
      else{
        alert("Sie müssen zunächst den Geschäftsbedingungen zustimmen");
        return false;
      }
    });
  });
  